export const blankRosterPosition = {
  _searchValue: "",
  _retrieved: false,
  usbcIdError: false,
  averageRequired: false,
  bowler: { },
  usbcId: ""
};



// WEBPACK FOOTER //
// ./src/features/registration/shared/dataModel.js